/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Collapse from '@/components/Collapse/Collapse'
import CollapseItem from '@/components/Collapse/CollapseItem'
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
import { BootstrapVue } from "bootstrap-vue";
import 'bootstrap-vue/dist/bootstrap-vue.css';
import store from './store'
Vue.use(BootstrapVue);
import VuexFlash from 'vuex-flash';
Vue.use(VuexFlash, { mixin: true });

// router setup
import router from './routes/router';
// plugin setup
Vue.use(DashboardPlugin);

var Lang = require("vuejs-localization");
Lang.requireAll(require.context("./lang", true, /\.js$/));
Vue.use(Lang);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});
